<template>
  <v-container
    fluid
    style="height: 100%; margin:0px; padding:0px; min-height: inherit"
    class="d-flex flex-row"
  >
    <volunteer-profile-left-section class="hidden-sm-and-down" />
    <volunteer-profile-agencies-section />
  </v-container>
</template>
<script>
import VolunteerProfileAgenciesSection from "./VolunteerProfileAgenciesSection.vue";
import VolunteerProfileLeftSection from "./VolunteerProfileLeftSection.vue";
export default {
  components: { VolunteerProfileLeftSection, VolunteerProfileAgenciesSection }
};
</script>
